import React from 'react';

export const SearchIcon = ({
    fill = '#000000',
    stroke = '#000000',
}: {
    fill?: string;
    stroke?: string;
}) => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 30 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="nonzero"
                clipRule="nonzero"
                d="M12.9177 14.8666L14.0081 14.5172L13.8262 13.9497L13.2571 13.7731L12.9177 14.8666ZM16.4471 25.8784L15.3567 26.2279C15.5047 26.6896 15.9275 27.0081 16.4121 27.0229C16.8968 27.0377 17.3382 26.7457 17.5141 26.2938L16.4471 25.8784ZM25.7177 2.06665L26.7847 2.48207C26.95 2.05755 26.8479 1.57544 26.5247 1.25436C26.2015 0.933282 25.7188 0.834318 25.2953 1.00235L25.7177 2.06665ZM2 11.4784L1.57766 10.4141C1.12643 10.5932 0.837159 11.0373 0.855807 11.5224C0.874455 12.0075 1.19697 12.4281 1.66061 12.572L2 11.4784ZM12.9177 14.8666L11.8273 15.2161L15.3567 26.2279L16.4471 25.8784L17.5375 25.5289L14.0081 14.5172L12.9177 14.8666ZM16.4471 25.8784L17.5141 26.2938L26.7847 2.48207L25.7177 2.06665L24.6507 1.65123L15.3801 25.463L16.4471 25.8784ZM25.7177 2.06665L25.2953 1.00235L1.57766 10.4141L2 11.4784L2.42234 12.5427L26.14 3.13095L25.7177 2.06665ZM2 11.4784L1.66061 12.572L12.5783 15.9602L12.9177 14.8666L13.2571 13.7731L2.33939 10.3848L2 11.4784Z"
                fill={fill}
            />
            <line
                y1="-1.14504"
                x2="18.2351"
                y2="-1.14504"
                transform="matrix(0.707107 -0.707106 0.707107 0.707106 13.106 16.4668)"
                stroke="white"
                strokeWidth="2.29008"
            />
        </svg>
    );
};
